import { useState } from 'react'
import { LOAD_TABS } from 'apps/fleet-planner/constants'

interface IUseLoadTabsOptions {
  /**
   * Determines the initial state of the hook
   * @default LOAD_TABS.loadDetails
   */
  defaultTab?: LOAD_TABS
}

const DEFAULT_OPTIONS: IUseLoadTabsOptions = {
  defaultTab: LOAD_TABS.loadDetails,
}

/**
 * Manages the tabs in <LoadDetails />
 */
export const useLoadTabs = ({
  defaultTab = LOAD_TABS.loadDetails,
}: IUseLoadTabsOptions = DEFAULT_OPTIONS) => {
  const [activeTab, setActiveTab] = useState<LOAD_TABS>(defaultTab)

  return {
    activeTab,
    setActiveTab,
  }
}
